import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import { withRouter } from 'react-router-dom';
import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import {Nav, NavItem, OverlayTrigger, Popover, Tooltip} from 'react-bootstrap';
import Select from 'react-select';

const tooltipSchools = (
    <Tooltip id="tooltipSchools">
        Multiple Select Option
    </Tooltip>
);
const getValue = (opts, val) => opts.find(o => o.value == val);

let addClassInstruction = null;
let addStudentInstruction = null;
let schoolOptions = [];


class SchoolAdminManagementComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { schoolAdmins: [], schoolAdminToEdit: {}, addSchoolAdmin: false, editSchoolAdmin: false };
        this.handleAddSchoolAdmin = this.handleAddSchoolAdmin.bind(this);
    }

    async componentDidMount() {
        await this.listSchoolAdmins();
        await REST.listSchools().then(async(response) => {
            if (response.success) {
                schoolOptions = [];
                let data = response.body;
                for (let school of data) {
                    schoolOptions.push({value: school.id, label: school.name});
                }
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    listSchoolAdmins() {
        REST.listSchoolAdmins().then((response) => {
            if (response.success) {
                this.setSchoolAdmins(response.body);
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    setSchoolAdmins = (object) => {
        this.setState({ schoolAdmins: object });
    }

    handleAddSchoolAdmin(event) {
        this.setState({ addSchoolAdmin: !this.state.addSchoolAdmin, editSchoolAdmin: false });
    }

    handleCancel = () => {
        this.setState({ addSchoolAdmin: false, editSchoolAdmin: false });
    }

    handleSchoolAdminItemClick = (object) => {
        this.setState({ addSchoolAdmin: false, editSchoolAdmin: true, schoolAdminToEdit: null });
        this.handleAddSchoolAdmin();
        this.setState({ addSchoolAdmin: false, editSchoolAdmin: true, schoolAdminToEdit: object });
        console.log(object);
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    schoolAdminAdded = async () => {
        this.listSchoolAdmins();
    }

    render() {
        return (
            <div>
                <HeaderComponent schoolAdminManagement={true}  logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                    <div className={"col-md-10"}>
                                        <h1 className="fl">School Admins</h1>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <a className="fr">
                                            <img src={ico_plus_green} onClick={this.handleAddSchoolAdmin} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable">
                                    <SchoolAdminsListComponent schoolAdmins={this.state.schoolAdmins} handleItemClick={this.handleSchoolAdminItemClick} />
                                </div>
                            </div>
                            {this.state.addSchoolAdmin ?
                                <div className="col-md-9 container navbar-container">
                                    <AddSchoolAdminComponent handleSchoolAdminAdded={this.schoolAdminAdded} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editSchoolAdmin ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateSchoolAdminComponent handleSchoolAdminUpdated={this.schoolAdminAdded} schoolAdmin={this.state.schoolAdminToEdit} handleCancel={this.handleCancel} />
                                </div> : null}
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

class AddSchoolAdminComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            username: '',
            email: '',
            modalDialog:false,
            responseContent:'',
            schools: []
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleSchoolsChange = this.handleSchoolsChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleName(event) {
        this.setState({ firstname: event.target.value });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value });
        event.preventDefault();
    }

    handleUsername(event) {
        this.setState({ username: event.target.value });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    async handleSchoolsChange(value) {
        let values = [];
        for (let opt of value){
            values.push(opt.value);
        }
        await this.setState({ schools: values});

    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.createSchoolAdmin(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'School Admin Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},2500);
                this.props.handleSchoolAdminAdded();
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},2500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddSchoolAdmin" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputSchoolAdminName">First Name</label>
                    <input type="text" onChange={this.handleName} id="inputSchoolAdminName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputSchoolAdminLastName">Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputSchoolAdminLastName" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputSchoolAdminLastName">Username</label>
                    <input type="text" onChange={this.handleUsername} id="inputSchoolAdminUsername" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputSchoolAdminEmail">Email</label>
                    <input type="text" onChange={this.handleEmail} id="inputSchoolAdminEmail" className="form-control" placeholder="Email" required />
                    <label htmlFor="inputAdminSchools">Schools</label>
                    <OverlayTrigger placement="top" overlay={tooltipSchools}>
                        <Select  onChange={this.handleSchoolsChange} id="inputAdminSchools" className="basic-multi-select" options={schoolOptions} className={this.state.schoolError} isMulti={true} isSearchable={false} />
                    </OverlayTrigger>
                    <br/>
                </form>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdateSchoolAdminComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: this.props.schoolAdmin.user.firstname,
            lastname: this.props.schoolAdmin.user.lastname,
            email: this.props.schoolAdmin.user.email,
            userId: this.props.schoolAdmin.userId,
            schools: [],
            schoolRecords: this.props.schoolAdmin.schools,
            modalDialog:false,
            modalDialogDelete:false,
            schoolValues: []
        };
        this.getSchools = this.getSchools.bind(this);
        this.getSchoolValues = this.getSchoolValues.bind(this);
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUserId = this.handleUserId.bind(this);
        this.handleSchoolsChange = this.handleSchoolsChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteSchoolAdmin = this.deleteSchoolAdmin.bind(this);
    }

    componentDidMount() {
        this.setState({
            firstname: this.props.schoolAdmin.user.firstname,
            lastname: this.props.schoolAdmin.user.lastname,
            username: this.props.schoolAdmin.user.username,
            email: this.props.schoolAdmin.user.email,
            userId: this.props.schoolAdmin.userId,
            schoolValues: [],
            modalDialog:false,
            modalDialogDelete:false });
        this.getSchools(this.props.schoolAdmin.schools);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.schoolAdmin.userId !== newProps.schoolAdmin.userId){
            this.setState({
                firstname: this.props.schoolAdmin.user.firstname,
                lastname: this.props.schoolAdmin.user.lastname,
                username: this.props.schoolAdmin.user.username,
                email: this.props.schoolAdmin.user.email,
                userId: this.props.schoolAdmin.userId,
                schoolValues: [],
                modalDialog:false,
                modalDialogDelete:false });
            this.getSchools(this.props.schoolAdmin.schools);
        }
    }

    async getSchools(values) {
        let schools = []
        for (let i = 0; i < values.length; i++){
            schools[i] =  parseInt(values[i].id);
        }
        await this.setState({schools:schools});
        return false;
    }

    getSchoolValues(values) {
        let valueArray = [];
        if(values){
            valueArray = values.split(',');
        }
        this.state.schoolValues = [];
        for (let i = 0; i < valueArray.length; i++){
            this.state.schoolValues.push(getValue(schoolOptions, valueArray[i]));
        }
        return false;
    }

    async handleSchoolsChange(value) {
        let values = [];
        if(value){
            for (let opt of value){
                values.push(opt.value);
            }
        }
        await this.setState({ schools: values});
    }

    deleteSchoolAdmin = (confirm) =>{
        if(confirm) {
            this.handleDelete();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleFirstName(event) {
        this.setState({ firstname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleUsername(event) {
        this.setState({ username: event.target.value });
        event.preventDefault();
    }

    handleUserId(event) {
        this.setState({ userId: event.target.value });
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateSchoolAdmin(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'School Admin Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
                this.props.handleSchoolAdminUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteSchoolAdmin(this.state.userId).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'School Admin Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},2500);
                this.props.handleSchoolAdminUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        this.getSchoolValues(this.state.schools.toString());
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deleteSchoolAdmin}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputSchoolAdminName">First Name</label>
                    <input type="text" value={this.state.firstname} onChange={this.handleFirstName} id="inputSchoolAdminName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputSchoolAdminLastName">Last Name</label>
                    <input type="text" value={this.state.lastname} onChange={this.handleLastName} id="inputSchoolAdminLastName" className="form-control" placeholder="Last Name" required />
                    {/*<label htmlFor="inputSchoolAdminEmail">Email</label>*/}
                    {/*<input type="text" onChange={this.handleEmail} id="inputSchoolAdminEmail" value={this.state.email} className="form-control" placeholder="Email" required />*/}
                    <label htmlFor="inputSchoolAdminUserId">User Name</label>
                    <input type="text" value={this.state.username} onChange={this.handleUsername} id="inputSchoolAdminUserId" className="form-control" placeholder="Username" required />
                    <label htmlFor="inputAdminSchools">Schools</label>
                    <OverlayTrigger placement="top" overlay={tooltipSchools}>
                        <Select  onChange={this.handleSchoolsChange} id="inputAdminSchools" value={this.state.schoolValues} className="basic-multi-select" options={schoolOptions} className={this.state.schoolError} isMulti={true} isSearchable={false} />
                    </OverlayTrigger>
                    <br />
                </form>
                <div className="nav navbar fl">
                    <a onClick={(event)=>{this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS SCHOOL ADMIN?'});   event.stopPropagation();}} className="handBtn">
                        <span>Delete School Admin</span>
                    </a>
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class SchoolAdminsListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    render() {
        let items = this.props.schoolAdmins;
        const schoolAdmins = items.map((item) => {
            if (item.user) {
                return <SchoolAdminsListItemComponent key={item.id} item={item} handleClick={this.handleItemClick} />
            }
            else return null;
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {schoolAdmins}
                </tbody>
            </table>
        );
    }
}

class SchoolAdminsListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr className="clickable-row" onClick={this.handleClick}>
                <td>{this.props.item.user.lastname}, {this.props.item.user.firstname}</td>
                <td className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

export default withRouter(SchoolAdminManagementComponent);